import { useState } from 'react'

import type { SectionsVideoComponent } from '@twisto/api-cms'

import { StrapiMedia } from 'homepage/components/atoms'
import { useHighlightedText } from 'homepage/libs/hooks'

import { PlayButton } from './play-button'
import * as styles from './video.styles'

export function Video({
  title,
  titleHighlight,
  description,
  descriptionHighlight,
  video,
  autoplay,
}: SectionsVideoComponent) {
  const [playbackStarted, setPlayBackStarted] = useState(false)

  const {
    before: titleBefore,
    highlight: highlightTitle,
    after: titleAfter,
  } = useHighlightedText(title, titleHighlight)

  const {
    before: descBefore,
    highlight: descHighlight,
    after: descAfter,
  } = useHighlightedText(description, descriptionHighlight)

  return (
    <div css={styles.wrap}>
      <div css={styles.title}>
        {titleBefore}
        <span>{highlightTitle}</span>
        {titleAfter}
      </div>

      <div css={styles.mediaWrapper}>
        <StrapiMedia
          {...video}
          autoPlay={autoplay}
          css={styles.video}
          onPlay={() => setPlayBackStarted(true)}
        />

        {!playbackStarted && !autoplay && <PlayButton />}

        <div css={styles.desc}>
          {descBefore}
          <strong>{descHighlight}</strong>
          {descAfter}
        </div>
      </div>
    </div>
  )
}
